const BarbadosSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_110857)">
      <path
        d="M28.6953 1.98453C26.066 0.713125 23.1161 0 19.9997 0C16.8833 0 13.9335 0.713125 11.3041 1.98453L9.56494 20L11.3041 38.0155C13.9335 39.2869 16.8833 40 19.9997 40C23.1161 40 26.066 39.2869 28.6953 38.0155L30.4345 20L28.6953 1.98453Z"
        fill="#FFDA44"
      />
      <path
        d="M11.3044 1.98535C4.61453 5.2202 0 12.0709 0 20.0001C0 27.9293 4.61453 34.78 11.3044 38.0149V1.98535Z"
        fill="#0052B4"
      />
      <path
        d="M28.6958 1.98535V38.0149C35.3856 34.78 40.0002 27.9293 40.0002 20.0001C40.0002 12.071 35.3856 5.2202 28.6958 1.98535Z"
        fill="#0052B4"
      />
      <path
        d="M26.0871 12.1737L27.2538 12.757L26.0871 12.1737L24.9204 11.5904C24.8501 11.7311 23.3267 14.8306 23.0779 19.565H21.3046V12.1737L20.0002 10.4346L18.6958 12.1737V19.565H16.9224C16.6735 14.8306 15.1503 11.7311 15.0799 11.5904L12.7466 12.7571C12.7627 12.7891 14.3481 16.0161 14.3481 20.8694V22.1738H18.6959V29.5651H21.3046V22.1738H25.6524V20.8693C25.6524 18.3601 26.0865 16.2911 26.4508 14.9971C26.8479 13.5862 27.2513 12.7622 27.2553 12.754L26.0871 12.1737Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_110857">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default BarbadosSvg;
